<template>
    <div>
        <b-form-group>
            <b-row>
                <b-col class="text-right">
                    <span v-if="!!minLabel">{{ minLabel }}</span>
                </b-col>
                <b-col cols="auto">
                    <b-form-radio-group>
                        <b-form-radio v-for="i in range" :key="i" :value="i" name="qualification" @change="$emit('input', i)">{{ i }}</b-form-radio>
                    </b-form-radio-group>
                </b-col>
                <b-col>
                    <span v-if="!!maxLabel">{{ maxLabel }}</span>
                </b-col>
            </b-row>
        </b-form-group>
    </div>
</template>
<script>
export default {
    props: {
        min: {
            type: [String, Number],
            default: 1
        },
        max: {
            type: [String, Number],
            default: 5
        },
        minLabel: {
            type: String
        },
        maxLabel: {
            type: String
        },
    },
    data: () => ({
        //
    }),
    computed: {
        range() {
            const range = []
            for(let i = parseInt(this.min); i <= parseInt(this.max); i++) {
                range.push(i)
            }
            return range
        }
    },
    methods: {
        //
    },
}
</script>
